import axios from "@/libs/api.request.js";
import { WX_URL } from "@/config";


// 埋点接口
export const eventTrackApi = (data) => axios.request({ url: "/box-user/bt-user/event-track", data: {...data, btos: 'h5'} });

// 转区接口
export const transferApi = () => axios.request({ url: "/box-active/bt-active/trans-actives", method: "get" });

// 获取游戏列表
export const getGameList = (data) => axios.request({ url: "/box-game/bt-game/getGameList", data, requireToken: true });

// 获取区服角色信息
export const getServerList = (data) => axios.request({ url: "/box-game/bt-game/getRegionRoleInfo", data, requireToken: true });

// 绑定角色
export const bindRole = (data) => axios.request({ url: "/box-active/signInActivity/bindRole", data, requireToken: true });

// 签到
export const signIn = (data) => axios.request({ url: "/box-active/signInActivity/signIn", data, requireToken: true });

// 获取签到活动列表
export const getActList = (data) => axios.request({ url: "/box-active/signInActivity/activityList", data, requireToken: true });

// 领取礼包
export const drawGift = (data) => axios.request({ url: "/box-active/signInActivity/drawGift", data, requireToken: true });

// 三盒子公用
export const getBoxDownloadInfo = (data) => axios.request({
  url: "https://platform.hzwxbz2.cn/platform-box-game/out/downloadInfo",
  data,
  requireToken: true
});